<p class="au-body-text-grey" [ngClass]="class">{{ text ?? fallbackText }}</p>
